import axios from "axios";
import CONFIG from "./config";
import { saveAccessToken, getAccessToken, purgeAccessToken, saveRefreshToken, getRefreshToken, purgeRefreshToken } from "./accessToken";
import qs from 'qs'

const axiosUtil = axios.create({
    baseURL: process.env.NODE_ENV === "production" ?
        CONFIG.PROD_API_BASE_URL :
        CONFIG.DEV_API_BASE_URL,
    timeout: CONFIG.TIMEOUT,
});

const axiosAuth = axios.create({
    baseURL: CONFIG.PROD_API_BASE_URL_AUTH,
    timeout: CONFIG.TIMEOUT,
});

axiosUtil.interceptors.request.use((request) => {
    const accessToken = getAccessToken();
    request.headers.Authorization = `Bearer ${accessToken}`;
    return request;
});

axiosUtil.interceptors.response.use((response) => {
    return response;
}, async (error) => {
    const { config, response: { status, data } } = error
    const originalRequest = config
    if ((status === 401) ||
         (status === 500 && data?.errors[0]?.message === 'Token is expired')) {
        try{    
            const sso = CONFIG.PROD_API_BASE_URL_AUTH + 'token'
            const refresh = getRefreshToken()
            const LoginData = qs.stringify({
                grant_type: 'refresh_token',
                refresh_token: refresh,
                scope: 'offline_access%20openid',
            })
            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
            }
            await axios.post(`${sso}`, LoginData, { headers })
            .then(res => {
                saveAccessToken(res.data.access_token)
                saveRefreshToken(res.data.refresh_token)
            })
            .catch(error => {
                const { response: { status } } = error
                if (status !== 200) {
                    purgeAccessToken()
                    purgeRefreshToken()
                    const path = window.location.pathname
                    window.location.assign("/login?redirect=" + path);
                }
            })
        } catch (error) {
            const { response: { status } } = error
            if (status !== 200) {
                purgeAccessToken()
                purgeRefreshToken()
                const path = window.location.pathname
                window.location.assign("/login?redirect=" + path);
            }
        }
        const retryOriginalRequest = new Promise((resolve) => {
            const token = getAccessToken()
            originalRequest.headers.Authorization = `Bearer ${token}`
            resolve(axios(originalRequest))
        })
        return retryOriginalRequest
    }
    return Promise.reject(data)
});

export { axiosUtil, axiosAuth };
